import type { Locale } from './i18n'

// 言語コード→表示名/国旗の一覧。顧客側の言語切替 (LanguageSwitcher) のほか、
// 店舗管理画面の翻訳プレビュー (MenuLocalePreview / MenuTranslationsSheet)
// からも参照される。
// `short` は地球アイコンの横に出す 1〜2 文字 (#2115)。中国語は CN / TW より
// 「简 / 繁」の方が、どちらの字体かが一目で分かる。
export const languages: { code: Locale; label: string; flag: string; short: string }[] = [
  { code: 'ja', label: '日本語', flag: '🇯🇵', short: 'JA' },
  { code: 'en', label: 'English', flag: '🇺🇸', short: 'EN' },
  // #2115 中国語は簡体字と繁体字の 2 本。「中文」とだけ出すと、台湾・香港の
  // お客様がどちらか分からないので、必ずどちらかを書く。
  // 繁体字の訳は簡体字から機械変換 (OpenCC s2twp) で作る。
  { code: 'zh', label: '中文（简体）', flag: '🇨🇳', short: '简' },
  { code: 'zh-TW', label: '中文（繁體）', flag: '🇹🇼', short: '繁' },
  { code: 'ko', label: '한국어', flag: '🇰🇷', short: 'KO' },
  { code: 'fr', label: 'Français', flag: '🇫🇷', short: 'FR' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪', short: 'DE' },
  { code: 'es', label: 'Español', flag: '🇪🇸', short: 'ES' },
  { code: 'th', label: 'ไทย', flag: '🇹🇭', short: 'TH' },
  { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳', short: 'VI' },
  { code: 'id', label: 'Indonesia', flag: '🇮🇩', short: 'ID' },
]
